import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import manageMembersActionCreators from "~/store/manageMembers/actions";
import { MemberStatusEnum, RoutesEnum, StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import memberSchema from "~/forms/MemberForm/memberSchema";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
import { Alert } from "~/components-shared";
import manageMemberSelectors from "~/store/manageMembers/selectors";
import MemberForm from "~/forms/MemberForm";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const MemberUpdateModal = () => {
  const {
    t
  } = useTranslation();
  const member = useSelector(manageMemberSelectors.getSelected);
  const status = useSelector(manageMemberSelectors.getStatus);
  const error = useSelector(manageMemberSelectors.getError);
  const memberId = member?.id || "";
  const history = useHistory();
  const dispatch = useDispatch();
  const defaultValues = {
    status: member?.status || MemberStatusEnum.ACTIVE,
    roleId: member?.role.id || "",
    department: member?.department,
    level: member?.level,
    authorities: member?.authorities || [],
    pendingIntegrationChannels: member?.settings.pendingIntegrationChannels || false
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    resolver: yupResolver(memberSchema),
    defaultValues
  });
  useEffect(() => {
    if (member) {
      reset(defaultValues);
    }
  }, [memberId]);
  const onSubmit = handleSubmit(data => {
    if (memberId) {
      dispatch(manageMembersActionCreators.updateStarted(memberId, data, _ref => {
        let {
          data: newMember
        } = _ref;
        if (newMember) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("MemberUpdateModal.memberUpdated", {
              name: `${newMember.firstName} ${newMember.lastName}`
            }),
            timeout: 10000,
            actions: [{
              icon: "external-link",
              onClick: () => history.push(RoutesEnum.MEMBER.replace(":memberId", newMember.id))
            }]
          }));
        }
      }));
    }
  });
  const handleCancel = () => {
    dispatch(manageMembersActionCreators.actionChanged(undefined, undefined));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("MemberUpdateModal.updateMember"),
    onClose: handleCancel,
    maxWidth: "560px",
    fullWidth: true,
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(MemberForm, {
    control: control,
    watch: watch,
    setValue: setValue
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("MemberUpdateModal.saveMember")))));
};
export default MemberUpdateModal;